import { useEffect, useState } from "react";
import {
    Link,
    useLocation,
    useParams
} from "react-router-dom";
import { useRevvingApi } from "./useRevvingApi";
import Fuse from 'fuse.js';
import './Gallery.css';
import InfiniteScroll from 'react-infinite-scroll-component'
import switch_state from "../utils/switch_state.json";
import loadingIcon from "../img/icons/loading-icon.gif";
import raritysniperIcon from "../img/icons/raritysniper-icon.svg";
import openseaIcon from "../img/icons/opensea-icon.svg";

import Header from './Header';
import Footer from './Footer';

const initialSwitchState = switch_state;

const metadataType = [
    "tribe",
    "background",
    "weapon",
    "body",
    "bodypaint",
    "arm",
    "eye",
    "hair",
    "helmet",
    "armpaint",
    "mask",
    "clothe",
    "hair_front",
    "head_a",
    "head_b",
    "head_c", 
    "head_led",
    "backlight",
];

const options = {
    includeScore: true,
    useExtendedSearch: true,
    threshold: 0.0,
    keys: [
        "id",
        "token_id",
        "tribe",
        "background",
        "weapon",
        "body",
        "bodypaint",
        "arm",
        "eye",
        "hair",
        "helmet",
        "armpaint",
        "mask",
        "clothe",
        "hair_front",
        "head_a",
        "head_b",
        "head_c",
        "head_led",
        "backlight",
        "revving_total",
        "is_revving_started",
        "is_for_business",
    ]
}

function shuffle(array) {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}
// const result = shuffle(metadata);

function Loading() {
    return (
        <>
            <Header />
            <div className="Gallery__Loading">
                <img src={loadingIcon} alt="" />
            </div>
        </>
    )
}

function GalleryLoaded(props) {
    const location = useLocation(); // modal用に取得

    const [isRandom, setIsRandom] = useState(true);
    const [inputId, setInputId] = useState("");
    const [rpmSort, setRpmSort] = useState("Random"); // RPMでソートするためのState
    const [switchState, setSwithcState] = useState(initialSwitchState);
    const [switchFilterState, setSwitchFilterState] = useState([]);

    const fuse = new Fuse(props.metadata, options);
    const initialResult = fuse.search(" ");
    const [resultState, setResultState] = useState(initialResult);
    const [list, setList] = useState([]); // infinite scroll list
    const [pageIndex, setPageIndex] = useState(1);
    const [isHasMore, setIsHasMore] = useState(true);

    // detailsのopen/closeのstate
    const [detailsOpen, setDetailsOpen] = useState({
        tribe: false,
        background: false,
        weapon: false,
        body: false,
        bodypaint: false,
        arm: false,
        eye: false,
        hair: false,
        helmet: false,
        armpaint: false,
        mask: false,
        clothe: false,
        hair_front: false,
        head_a: false,
        head_b: false,
        head_c: false,
        head_led: false,
        backlight: false,
    }); // details open state
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    //next function(infinite scroll)
    const fetchMoreData = () => {
        setPageIndex(pageIndex + 1);
        setTimeout(() => {
            const pageNum = 40;
            if (resultState.length - list.length > 40) {
                setList(list.concat(resultState.slice(pageIndex * pageNum, pageIndex * pageNum + pageNum)));
            } else {
                // 最後の時は全て入れる
                setList(resultState);
                // ロードをfalseに
                setIsHasMore(false);
            }
        }, 1500)
    }

    const handleOnChange = (val1, val2) => {
        setSwithcState((prevState) => ({
            ...prevState,
            [val1]: {
                ...prevState[val1],
                [val2]: {
                    ...prevState[val1][val2],
                    isSwitch: !switchState[val1][val2].isSwitch,
                },
            }
        }));
    };

    // clear filter
    const clearFilter = () => {
        setSwithcState(initialSwitchState);
    }

    // isSwitchがtrueのものだけfilterで抜き出す
    const switchFilter = () => {
        // オブジェクトを配列に変更する
        const arr = Object.values(switchState);

        // isSwitchがtrueのものだけfilterで抜き出す
        const fil = arr.map((item) => {
            const values = Object.values(item);
            const result = values.filter((item) => {
                return item.isSwitch
            });
            return result;
        });
        // 中身のない配列を削除する
        const result = fil.filter((item) => {
            return item.length !== 0;
        });
        console.log(result);

        return result;
    }

    // ソートする
    // 検索したいオブジェクトを作成してfuseオブジェクトに渡す
    const sort = () => {
        // switchがtrueのもので配列を作る
        console.log(switchFilter());

        const orQuery = switchFilter().map((item) => {
            const result = item.map((output) => {
                return { [output.type]: `="${output.name}"` }
            });
            return result;
        });

        // query用に変換する
        const resultQuery = orQuery.map((item) => {
            return { $or: item }
        });

        // idソートがあればqueryに追加
        if (inputId !== "") {
            resultQuery.push({ $or: [{ token_id: `=${inputId}` }] });
        }

        // ソートクエリ
        const query = {
            $and: resultQuery
        }

        // const result = fuse.search(query)
        const serchQuery = fuse.search(query);

        let result = [];
        if (rpmSort === "Random") {
            // ランダム表示
            result = shuffle(serchQuery);
        } else {
            result = serchQuery.sort(function (a, b) {
                // rpm順だとキメラばかりの絵になるからtotal順でも良さそう
                if (rpmSort === "HighToLow") {
                    return b.item.rpm - a.item.rpm;
                } else if (rpmSort === "LowToHigh") {
                    return a.item.rpm - b.item.rpm;
                } else {
                    return a.item.token_id - b.item.token_id;
                }
            });
        }

        // チェックボックスにチェックがないときは全て表示
        if (switchFilter().length === 0 && result.length === 0 && inputId === "") {
            const allQuery = props.metadata;
            if (rpmSort === "Random") {
                // ランダム表示
                result = shuffle(allQuery).map((output) => {
                    return { item: output }
                });
            } else {
                // console.log('allQuery');
                // console.log(allQuery);
                const allSortQuery = allQuery.sort(function (a, b) {
                    // rpm順だとキメラばかりの絵になるからtotal順でも良さそう
                    if (rpmSort === "HighToLow") {
                        return b.rpm - a.rpm;
                    } else if (rpmSort === "LowToHigh") {
                        return a.rpm - b.rpm;
                    } else {
                        return a.token_id - b.token_id;
                    }
                });
                result = allSortQuery.map((output) => {
                    return { item: output }
                });
            }

            setResultState(result); // ソートしたデータ
            setList(result.slice(0, 40)); // ソートした中から40項目だけ表示する
            setPageIndex(1); // ページ番号を初期化

        } else {
            // チェックしたものを表示
            setResultState(result); // ソートしたデータ
            setList(result.slice(0, 40)); // ソートした中から40項目だけ表示する
            setPageIndex(1); // ページ番号を初期化
            setIsRandom(true);

            // resultが40以下ならロードしない
            result.length < 40 ? setIsHasMore(false) : setIsHasMore(true);
        }

        // console.log(orQuery);
        // console.log(resultQuery);
        // console.log(query);
        // console.log(serchQuery);
        // console.log(result);
        // console.log(rpmSort);
    };

    useEffect(() => {
        setSwitchFilterState(switchFilter());
        sort();
    }, [switchState, inputId, rpmSort]);

    const Checkbox = (props) => {
        return (
            <label className="Gallery__sidebar__checkbox">
                <input type="checkbox" checked={props.checked} onChange={props.onChange} />
                <span className="Gallery__sidebar__checkbox__img"></span>
                <span className="Gallery__sidebar__checkbox__text">{props.name}</span>
            </label>
        )
    };

    const SortList = (props) => {
        const type = Object.values(props.sortType)[0].type;

        const handle = () => {
            setDetailsOpen((prevState) => ({
                ...prevState,
                [type]: !detailsOpen[type]
            }));
        }

        return (
            <details open={detailsOpen[type]} className="Gallery__sidebar__details">
                <summary onClick={handle} className="Gallery__sidebar__summary">
                    <span>{type}</span>
                    <span className="Gallery__sidebar__summary__num">{Object.values(props.sortType).length}</span>
                </summary>
                {Object.values(props.sortType).map((item, index) => {
                    return (
                        <Checkbox name={item.name} checked={item.isSwitch} onChange={() => handleOnChange(item.type, item.key)} key={index} />
                    )
                })}
            </details>
        )
    };

    const GridItems = (
        <div className="Gallery__grid">
            {list.map((output, index) => {
                return (
                    <Link
                        key={index}
                        to={{
                            pathname: `/gallery/${output.item.token_id}`
                        }}
                        state={{ background: location, output: output.item }}
                        className="Gallery__itemLink"
                    >
                        <div key={index} className="Gallery__item">
                            <img src={`/gallery_images_webp_grid/${output.item.token_id}.webp`} alt="image" className="Gallery__item__img" />
                            <div className="Gallery__item__data">
                                <p className="Gallery__item__no">No. {output.item.token_id}</p>
                                <div className="Gallery__item__tagContainer">
                                    <p className="Gallery__item__tag">Revving <span className="Gallery__item__span">{output.item.is_revving_started ? "Revved" : "none"}</span></p>
                                    <p className="Gallery__item__tag">RPM <span className="Gallery__item__span">{output.item.rpm}</span></p>
                                </div>
                            </div>
                        </div>
                    </Link>
                )
            })}
        </div>
    );

    return (
        <div className="Gallery">

            <div className="Gallery__wrapper">
                <div className="Gallery__sidebar">

                    <input className="Gallery__sidebar__search" type="text" value={inputId} onChange={(event) => setInputId(event.target.value)} placeholder="Search by number" />

                    <div className="Gallery__sidebar__sortBtnContainer">
                        <button className="Gallery__sidebar__filterBtn" onClick={() => setIsSidebarOpen(true)}>Filters</button>

                        <select className="Gallery__sidebar__select" value={rpmSort} onChange={(event) => setRpmSort(event.target.value)} >
                            <option value="Random">Random</option>
                            <option value="HighToLow">RPM high to low</option>
                            <option value="LowToHigh">RPM low to high</option>
                            <option value="id">ID low to high</option>
                        </select>

                    </div>

                    {/* <div className="Gallery__sidebar__list"> */}
                    <div className={isSidebarOpen ? "Gallery__sidebar__list open" : "Gallery__sidebar__list close"} >
                        <div className="Gallery__sidebar__spHeading">
                            <h2 className="Gallery__sidebar__spHeading__h2">Filter <span>({resultState.length})</span></h2>
                            <button className="Gallery__sidebar__spHeading__closeBtn" onClick={() => setIsSidebarOpen(false)}>×</button>
                        </div>
                        <details open={true} className="Gallery__sidebar__details status">
                            <summary className="Gallery__sidebar__summary">status</summary>
                            <Checkbox name="Revved" checked={Object.values(switchState.is_revving_started)[0].isSwitch} onChange={() => handleOnChange(Object.values(switchState.is_revving_started)[0].type, Object.values(switchState.is_revving_started)[0].key)} />
                            {/* <Checkbox name="Commercial use available" checked={Object.values(switchState.is_for_business)[0].isSwitch} onChange={() => handleOnChange(Object.values(switchState.is_for_business)[0].type, Object.values(switchState.is_for_business)[0].key)} /> */}
                        </details>

                        {metadataType.map((item, index) => {
                            return (
                                <SortList sortType={switchState[item]} key={index} />
                            )
                        })}

                        <div className="Gallery__sidebar__list__btnContainer">
                            <button className="Gallery__item__clearBtn" onClick={() => clearFilter()}>Clear All</button>
                            <button className="Gallery__item__doneBtn" onClick={() => setIsSidebarOpen(false)}>DONE <span>({resultState.length})</span></button>
                        </div>
                    </div>
                </div>

                <div className="Gallery__main">
                    <div className="Gallery__filter">
                        {/* <span className="Gallery__filterTitle">FILTERS <span>({isRandom ? <span>Random</span> : <span>{resultState.length}</span>})</span></span> */}
                        <span className="Gallery__filterTitle">FILTERS <span>({resultState.length})</span></span>
                        {/* {isRandom ? <span className="Gallery__filterTag--random">Random</span> : null} */}

                        {switchFilterState.map((item, index) => {
                            return (
                                <span key={index}>
                                    {
                                        item.map((output, index) => {
                                            return (
                                                <button
                                                    onClick={() => handleOnChange(output.type, output.key)}
                                                    key={index}
                                                    className="Gallery__filterTag">
                                                    {output.type === "is_revving_started" ? "Revved" : null}
                                                    {output.type === "is_for_business" ? "Commercial use available" : null}
                                                    {output.type !== "is_revving_started" && output.type !== "is_for_business" ? output.name : null}
                                                    <span className="Gallery__filterTag__icon">×</span>
                                                </button>
                                            )
                                        })
                                    }
                                </span>
                            )
                        })}

                        {switchFilterState.length > 0 ? (
                            <button className="Gallery__filter__clearBtn" onClick={() => clearFilter()}>Clear All</button>
                        ) : null}
                        {/* <span>{resultState.length}</span> */}
                    </div>


                    <InfiniteScroll
                        dataLength={list.length}
                        next={fetchMoreData}
                        hasMore={isHasMore}
                        loader={<div className="Gallery__infiniteLoading"><img src={loadingIcon} alt="loading icon" /></div>}
                        scrollThreshold={0.9}
                        pullDownToRefresh={false}
                        refreshFunction={() => {
                            setTimeout(() => {
                                setList(list.concat(resultState.slice(pageIndex * 40, pageIndex * 40 + 40)))
                            }, 1500)
                        }}
                    >
                        {GridItems}
                    </InfiniteScroll>
                    {resultState.length === 0 ? (
                        <p className="Gallery__notFound">Not found.<br />
                            Please search using the filter function.</p>
                    ) : null}
                </div>
            </div >
        </div >
    )
}

export function Gallery() {
    const { revvingData, isLoading, isError } = useRevvingApi();

    // エラーの詳細をコンソールに出力
    useEffect(() => {
        if (isError) {
            console.error('[Gallery] Error Details:', {
                error: isError,
                message: isError?.message,
                stack: isError?.stack,
                name: isError?.name,
                status: isError?.status,
                statusText: isError?.statusText,
                responseBody: isError?.responseBody
            });
        }
    }, [isError]);

    if (isLoading) return <Loading />;
    if (isError) {
        console.error('[Gallery] Failed to load revving data', isError);
        
        // データベース接続エラーの場合のメッセージ
        if (isError.status === 500) {
            return (
                <div>
                    <Header />
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <h2>データの読み込みに失敗しました</h2>
                        <p>サーバーのデータベース接続に問題があります。</p>
                        <p>しばらくしてから再度お試しください。</p>
                    </div>
                    <Footer />
                </div>
            );
        }
        
        return <div>failed to load</div>;
    }

    // metadataとrevvingDataを合体させる
    const result = revvingData.map((item, index) => {
        // item.revving_total = revvingData[index].revving_total;
        // item.is_revving_started = revvingData[index].is_revving_started;
        // item.is_for_business = revvingData[index].is_for_business;
        //npm計算
        if (item.tribe === "Human") {
            item.rpm = Math.floor(revvingData[index].revving_total / 600);
        }
        if (item.tribe === "Mecha") {
            item.rpm = Math.floor(revvingData[index].revving_total / 570);
        }
        if (item.tribe === "Chimera") {
            item.rpm = Math.floor(revvingData[index].revving_total / 540);
        }
        return item;
    })

    return (
        <>
            <Header />
            <GalleryLoaded metadata={result} />
            <Footer />
        </>
    )
}

function ModalComponent({ result }) {
    const PartsBlock = ({ name, body }) => {
        return (
            <div className="Gallery__modal__PartsBlock">
                <p className="Gallery__modal__PartsBlock__name">{name}</p>
                <p className="Gallery__modal__PartsBlock__body">{body ? body : "-"}</p>
            </div>
        )
    }

    const backgroundColorCalc = () => {
        if (result.background === "Red Background") {
            return "Gallery__modal__content red"
        }
        if (result.background === "Light Purple Background") {
            return "Gallery__modal__content lightPurple"
        }
        if (result.background === "Blue Background") {
            return "Gallery__modal__content blue"
        }
        if (result.background === "Pink Background") {
            return "Gallery__modal__content pink"
        }
        if (result.background === "Purple Background") {
            return "Gallery__modal__content purple"
        }
        return "Gallery__modal__content"
    }

    return (
        <div className="Gallery__modal">
            <Link to="/gallery" className="Gallery__modal__background">
            </Link>
            <div className={backgroundColorCalc()}>
                <Link to="/gallery" className="Gallery__modal__closeBtn--top">×</Link>

                <img className="Gallery__modal__img" src={`/gallery_images_webp/${result.token_id}.webp`} alt="image" />
                <div className="Gallery__modal__rightContainer">
                    <div className="Gallery__modal__plate">
                        <p className="Gallery__modal__plate__no">No. {result.token_id}</p>
                        <div className="Gallery__modal__plate__linkContainer">
                            <p className="Gallery__modal__plate__driveTo">Drive to</p>
                            <a href={`https://opensea.io/assets/ethereum/0xf10a5f9feef5b3c52c7ca71dc11e467b727c7222/${result.token_id}`} className="Gallery__modal__plate__openseaIcon" target="_blank">
                                <img src={openseaIcon} alt="opensea icon" />
                            </a>
                            <a href={`https://raritysniper.com/bosotokyo/${result.token_id}`} className="Gallery__modal__plate__openseaIcon" target="_blank">
                                <img src={raritysniperIcon} alt="raritysniper icon" />
                            </a>
                        </div>
                    </div>
                    <div className="Gallery__modal__body">

                        <div className="Gallery__modal__PartsBlock">
                            <p className="Gallery__modal__PartsBlock__name">Revving / RPM</p>
                            <p className="Gallery__modal__PartsBlock__body">{result.is_revving_started ? "Revved" : "none"} / {result.rpm}</p>
                        </div>
                        {/* <PartsBlock name="Commercial use" body={result.is_for_business ? "Available" : "Not Available for Rent"} /> */}
                        {metadataType.map((item, index) => {
                            return (
                                <PartsBlock name={item} body={result[item]} key={index} />
                            )
                        })}

                        <Link to="/gallery" className="Gallery__modal__closeBtn">Close</Link>
                    </div>
                </div>
            </div>
        </div >
    )
}

// galleryからmodalにリンクした場合 
export function Modal() {
    const location = useLocation();

    if (location.state.output) {
        const result = location.state.output;

        return (
            <ModalComponent result={result} />
        )
    }
}

// urlから飛んできた場合（apiからデータを取得する必要がある）
export function NftPage() {
    let { id } = useParams();

    const { revvingData, isLoading, isError } = useRevvingApi();
    
    // エラーの詳細をコンソールに出力
    useEffect(() => {
        if (isError) {
            console.error('[NftPage] Error Details:', {
                error: isError,
                message: isError?.message,
                stack: isError?.stack,
                name: isError?.name,
                status: isError?.status,
                statusText: isError?.statusText,
                responseBody: isError?.responseBody,
                tokenId: id
            });
        }
    }, [isError, id]);
    
    if (isLoading) return <Loading />
    if (isError) {
        console.error('[NftPage] Failed to load revving data', isError);
        return <div>failed to load</div>
    }

    const result = revvingData.map((item, index) => {
        if (item.tribe === "Human") {
            item.rpm = Math.floor(revvingData[index].revving_total / 600);
        }
        if (item.tribe === "Mecha") {
            item.rpm = Math.floor(revvingData[index].revving_total / 570);
        }
        if (item.tribe === "Chimera") {
            item.rpm = Math.floor(revvingData[index].revving_total / 540);
        }
        return item;
    })

    return (
        <>
            {/* <Header /> */}
            <ModalComponent result={result[id]} />
        </>
    )
}